import React from "react";

export const FavouriteVehiclesContext = React.createContext();